// extracted by mini-css-extract-plugin
export var avatar = "_pf-3";
export var avatarContainer = "_pf-2";
export var avatarSpacer = "_pf-5";
export var avatarSpacerContainer = "_pf-4";
export var avatarStackContainer = "_pf-1";
export var bubble = "_pf-0";
export var remainderBubble = "_pf-6";